import BranchComponent from '../components/branch/branchs'

const Branch = () => <BranchComponent />

export default Branch;